import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA } from '@angular/material/dialog';
import { Store } from '@ngrx/store';
import { Observable } from 'rxjs';

import { IUTEventVessel } from '@ruby/modules/unit-train/models/unit-train-permit.interface';
import { fromVesselEvent, VesselEventActions, VesselEventSelectors } from '@ruby/modules/unit-train/store/vessel-event.index';

@Component({
  selector: 'ng-vessel-event-container',
  templateUrl: './vessel-event.container.html'
})
export class VesselEventContainer {
  store$: Observable<fromVesselEvent.State>;
  event: IUTEventVessel;

  constructor(private store: Store, @Inject(MAT_DIALOG_DATA) private data: { event: IUTEventVessel }) {
    this.store$ = this.store.select(VesselEventSelectors.selectVesselEventState);
    this.event = data.event;
    this.getVesselEvent();
  }

  /**
   * Get Vessel Event
   *
   * @summary Dispatch action to get vessel event
   * @returns void
   */
  getVesselEvent(): void {
    this.store.dispatch(VesselEventActions.getVesselEvent({ data: { eventId: this.event.eventId } }));
  }
}
